import React from 'react';
const styles = {"rule":"Divider-module__rule__Na8cu","labelled":"Divider-module__labelled__6bool","line":"Divider-module__line__WAf7G","label":"Divider-module__label__5YAlN"};
/** A horizontal rule between two groups (Sign in · C1, the "or" before "Continue with Google"). */
export function Divider({ label }) {
    let divider = React.createElement("hr", { className: styles.rule });
    if (label !== undefined) {
        divider = (React.createElement("div", { className: styles.labelled, role: "separator", "aria-label": label },
            React.createElement("span", { className: styles.line }),
            React.createElement("span", { className: styles.label, "aria-hidden": "true" }, label),
            React.createElement("span", { className: styles.line })));
    }
    return divider;
}
//# sourceMappingURL=Divider.js.map